"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var GetDefaultBlockStyle_1 = __importDefault(require("DreamCoat/StyleShortcut/DefaultBlockStyles/GetDefaultBlockStyle"));
var DefaultColors_1 = require("@CommonFrontendBackend/StyleServiceV2/Config/DefaultColors");
var commonTypes_1 = require("@CommonFrontendBackend/StyleServiceV2/Config/BlockConfig/commonTypes");
exports.default = (function (v0Style, colorsWithThemeIndex) {
    var style = (0, GetDefaultBlockStyle_1.default)(v0Style.blockType, colorsWithThemeIndex);
    style.name = v0Style.name;
    style.preTcdcRef = v0Style.className;
    if (["qwilr-standard-centered", "qwilr-impact", "qwilr-impact-ii"].includes(v0Style.className)) {
        style.h1.alignment = commonTypes_1.AlignmentTypes.Center;
        style.h2.alignment = commonTypes_1.AlignmentTypes.Center;
        style.p.alignment = commonTypes_1.AlignmentTypes.Center;
    }
    if (v0Style.className === "qwilr-monochrome") {
        style.h1.color = {
            themeIndex: DefaultColors_1.DEFAULT_MIDNIGHT.themeIndex,
            abs: DefaultColors_1.DEFAULT_MIDNIGHT.value,
        };
        style.h2.color = {
            themeIndex: DefaultColors_1.DEFAULT_MIDNIGHT.themeIndex,
            abs: DefaultColors_1.DEFAULT_MIDNIGHT.value,
        };
        style.p.color = {
            themeIndex: DefaultColors_1.DEFAULT_MIDNIGHT.themeIndex,
            abs: DefaultColors_1.DEFAULT_MIDNIGHT.value,
        };
        style.blockQuote.color = {
            themeIndex: DefaultColors_1.DEFAULT_MIDNIGHT.themeIndex,
            abs: DefaultColors_1.DEFAULT_MIDNIGHT.value,
        };
    }
    if (v0Style.className.includes("qwilr-impact")) {
        style.h1.color = {
            themeIndex: DefaultColors_1.DEFAULT_WHITE.themeIndex,
            abs: DefaultColors_1.DEFAULT_WHITE.value,
        };
        style.h2.color = {
            themeIndex: DefaultColors_1.DEFAULT_WHITE.themeIndex,
            abs: DefaultColors_1.DEFAULT_WHITE.value,
        };
        style.p.color = {
            themeIndex: DefaultColors_1.DEFAULT_WHITE.themeIndex,
            abs: DefaultColors_1.DEFAULT_WHITE.value,
        };
        style.blockQuote.color = {
            themeIndex: DefaultColors_1.DEFAULT_WHITE.themeIndex,
            abs: DefaultColors_1.DEFAULT_WHITE.value,
        };
    }
    if (["qwilr-impact", "qwilr-impact-left"].includes(v0Style.className)) {
        style.background = {
            themeIndex: colorsWithThemeIndex[1].themeIndex,
            abs: colorsWithThemeIndex[1].value,
        };
    }
    if (["qwilr-impact-ii", "qwilr-impact-ii-left"].includes(v0Style.className)) {
        style.background = {
            themeIndex: colorsWithThemeIndex[0].themeIndex,
            abs: colorsWithThemeIndex[0].value,
        };
    }
    return style;
});
